import { BillPayGenerateEmbedUrlRequest } from 'vopay';
import { useEffect, useState } from 'react';
import axios from 'axios';
import vopayApi from '@/services/api.config';
const { api } = vopayApi;
import { useDataFetchIndicator } from '..';

export default function useGenerateBillPayEmbedUrl() {
  const source = axios.CancelToken.source();
  const [link, setLink] = useState<string>();

  const [, setDataFetchingInfo] = useDataFetchIndicator();
  useEffect(() => {
    return () => {
      source.cancel();
    };
  }, []);

  const generateBillPayEmbedUrl = async (request: BillPayGenerateEmbedUrlRequest) => {
    try {
      setDataFetchingInfo(true);
      const res = await api.generateBillPayEmbedUrl(request, source);
      if (!res.Success) throw new Error(res.ErrorMessage);
      setLink(res.Link);
      return res;
    } catch (err) {
      console.error(err);

      throw err;
    } finally {
      setDataFetchingInfo(false);
    }
  };

  return {
    link,
    generateBillPayEmbedUrl,
  };
}
